import { getNodeLink } from '@livv/utils/helpers';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, SxProps } from '@mui/material';
import { FC } from 'react';
import { PlainLink } from '@components/Links';
import { useBookPageContext } from '@utils/context/book';
import { useBookPathSlugs } from '@utils/hooks/useBookSlugs';
import { usePathTitles } from '@utils/hooks/usePathTitlesAndMetaDescription';

interface PathBreadcrumbProps {
    sx: SxProps;
}

const PathBreadcrumbs: FC<PathBreadcrumbProps> = ({ sx }) => {
    const { bookData, bookMeta } = useBookPageContext();
    const { bookId, bookPath } = useBookPathSlugs();
    const path = bookPath.split('/');
    const pathTitles = usePathTitles(path, bookData, bookMeta);

    return (
        <Box sx={sx}>
            <Breadcrumbs
                aria-label="breadcrumb"
                data-test-id="path-breadcrumbs"
                separator={<NavigateNextIcon fontSize="small" />}
                sx={{ color: 'grey.400', mb: 2 }}
            >
                {pathTitles.filter(Boolean).map((pathTitle) => (
                    <PlainLink
                        key={pathTitle?.title}
                        href={getNodeLink({
                            bookId,
                            bookPath: pathTitle?.subpath?.join('/') ?? '',
                        })}
                        sx={{
                            color: 'grey.400',
                            display: 'flex',
                            fontSize: 12,
                            lineHeight: 1,
                        }}
                    >
                        {pathTitle?.title}
                    </PlainLink>
                ))}
            </Breadcrumbs>
        </Box>
    );
};

export default PathBreadcrumbs;
